export const staticDataReducer = (state = [], action) => {
  switch (action.type) {
    case 'STATIC_DATA_INIT': {
      state.status = Object.assign({}, state.status, {
        isLoading: true,
        isError: false,
      })
      return Object.assign({}, state, action.payload)
    }
    case 'STATIC_DATA_SUCCESS': {
      state = Object.assign({}, state, action.payload)
      state.status = Object.assign({}, state.status, { isLoading: false, isError: false })
      return Object.assign({}, state)
    }
    case 'STATIC_DATA_FAILURE': {
      state.status = Object.assign({}, state.status, action.payload, {
        isLoading: false,
        isError: true,
      })
      return Object.assign({}, state)
    }
    default:
      return state
  }
}
